import React, { useEffect, useState } from 'react';
import '../css/About.css';

const teamMembers = [
  {
    name: 'Edwin Mui',
    position: 'Director of Infrastructure',
    description: '',
    photo: 'edwin_mui.jpg'
  },
  {
    name: 'Christopher Yuen',
    position: 'Team Member',
    description: 'small description',
    photo: 'chris_yuen_headshot_zoom.jpg'
  },
  {
    name: 'Shoi Amin',
    position: 'Team Member',
    description: 'small description',
    photo: 'shoi.jpg'
  },
  {
    name: 'Nevan Sujit',
    position: 'Team Member',
    description: 'small description',
    photo: 'nevan_headshot.jpg'
  },
  {
    name: 'Brandon Kong',
    position: 'Team Member',
    description: 'small description',
    photo: 'brandon.jpg'
  },
  
];

export function AboutOrg() {
  return (
    <section id="about" className="About-org">
      <div className="About-org-inner">
        <div className="About-org-grid">
          <div className="About-text">
            <div className="About-heading-row">
              <h1>About</h1>
              <img
                src="/slim white franklinDAO transparent.png"
                alt="FranklinDAO logo"
                className="About-logo-inline-right"
              />
            </div>
            <p>
              We are an off-campus organization founded by students studying at the University of Pennsylvania.
              We are part of the EduDAO initiative and are actively involved in various aspects of the Web3 space—due diligence/sourcing for VCs, software development, and key participants in governance forums all over Defi.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MeetTheTeam() {
  const [appear, setAppear] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const divider = document.querySelector('.SectionDivider');
    if (!divider) return;

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // When the divider is scrolled past (above viewport), entry.isIntersecting will be false
        // and boundingClientRect.y will be negative. Use that to show the team.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.y < 0;
        setAppear(scrolledPast);
      });
    }, { threshold: 0 });

    obs.observe(divider);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="meet-the-team" className="Team-section">
      <div className="Team-right">
        <div className="Team-right-inner">
          <h2 className="Team-heading">Meet the Team</h2>
          <p>
            The Infrastructure Team @FranklinDAO focuses on reliability, security, and
            automation. We operate and improve the platforms, CI/CD pipelines,
            and observability tooling that keep production running smoothly.
            We're a small, cross-functional group that collaborates closely
            with product and engineering teams to ship safely and quickly. (need to edit)
          </p>
          <p>
            If you'd like to learn more about our processes or open roles,
            reach out via the <a href="#contact" onClick={(e) => { e.preventDefault(); const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }}>contact channels</a> on this site.
          </p>
        </div>
      </div>

      {(() => {
        const director = teamMembers[0];
        const others = teamMembers.slice(1);

        // map members: top row uses others[0] and others[1] as flanking members
        const topLeft = others[0] || null;
        const topRight = others[1] || null;

        // bottom row: remaining members (we may have 0-3 items)
        const bottom = others.slice(2);
        let bottomLeft = null;
        let bottomCenter = null;
        let bottomRight = null;

        if (bottom.length === 3) {
          bottomLeft = bottom[0];
          bottomCenter = bottom[1];
          bottomRight = bottom[2];
        } else if (bottom.length === 2) {
          // Place the two items at left and right (leave center empty)
          bottomLeft = bottom[0];
          bottomCenter = null;
          bottomRight = bottom[1];
        } else if (bottom.length === 1) {
          // Single bottom member goes to center
          bottomLeft = null;
          bottomCenter = bottom[0];
          bottomRight = null;
        }

        return (
          <div className={"Team-members-grid" + (appear ? ' appear' : '')}>
            {/* top-left member */}
            <div className="member-slot slot-top-left">
              {topLeft && (
                <div className="Team-member">
                  <img src={topLeft.photo} alt={topLeft.name} className="Team-photo" />
                  <div className="Team-member-meta">
                    <h3 className="Team-member-name">{topLeft.name}</h3>
                    <p className="Team-position">{topLeft.position}</p>
                  </div>
                </div>
              )}
            </div>

            {/* director in center */}
            <div className="member-slot slot-top-center">
              <div className="Team-member Team-member--director Team-member--director-grid">
                <img src={director.photo} alt={director.name} className="Team-photo Team-photo--director" />
                <div className="Team-member-meta">
                  <h3 className="Team-member-name">{director.name}</h3>
                  <p className="Team-position">{director.position}</p>
                  <p className="Team-member-desc">{director.description}</p>
                </div>
              </div>
            </div>

            {/* top-right member */}
            <div className="member-slot slot-top-right">
              {topRight && (
                <div className="Team-member">
                  <img src={topRight.photo} alt={topRight.name} className="Team-photo" />
                  <div className="Team-member-meta">
                    <h3 className="Team-member-name">{topRight.name}</h3>
                    <p className="Team-position">{topRight.position}</p>
                  </div>
                </div>
              )}
            </div>

            {/* bottom row: spread remaining members across three columns */}
            <div className="member-slot slot-bottom-left">
              {bottomLeft && (
                <div className="Team-member">
                  <img src={bottomLeft.photo} alt={bottomLeft.name} className="Team-photo" />
                  <div className="Team-member-meta">
                    <h3 className="Team-member-name">{bottomLeft.name}</h3>
                    <p className="Team-position">{bottomLeft.position}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="member-slot slot-bottom-center">
              {bottomCenter && (
                <div className="Team-member">
                  <img src={bottomCenter.photo} alt={bottomCenter.name} className="Team-photo" />
                  <div className="Team-member-meta">
                    <h3 className="Team-member-name">{bottomCenter.name}</h3>
                    <p className="Team-position">{bottomCenter.position}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="member-slot slot-bottom-right">
              {bottomRight && (
                <div className="Team-member">
                  <img src={bottomRight.photo} alt={bottomRight.name} className="Team-photo" />
                  <div className="Team-member-meta">
                    <h3 className="Team-member-name">{bottomRight.name}</h3>
                    <p className="Team-position">{bottomRight.position}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}
    </section>
  );
}

// Default export kept for backward compatibility (renders both sections)
export default function About() {
  return (
    <div className="About">
      <AboutOrg />
      <MeetTheTeam />
    </div>
  );
}